import { ref, watch } from 'vue';
const mode =  ref('dark');
document.body.classList.add(mode.value);
watch(mode, (newMode, oldMode) => document.body.classList.replace(oldMode, newMode));
export function composables() {
  return { mode };
}
